import { connect } from 'react-redux';

import { addComment } from './actions';
import Replies from './Comments/Replies';

export default connect(null, { onReply: addComment })(Replies);
